<template>
  <div class="wrap" :class="{ fullscreen: fullscreen && isMobile }">
    <video
      playsinline
      v-if="!videoLoadingError"
      muted
      class="video"
      :class="{
        landscape: orientation,
        portrait: !orientation,
        'hide-menu': hideMenu,
      }"
      ref="video"
      @play="checkIfVideoEnded"
      @error="handleVideoError"
      @onerror="handleVideoError"
      @loadstart="stopLoading"
      :key="videoReset"
      :loop="videoEnded && loopLinks.length > 0"
    >
      <!-- @waiting="handleWaiting"
				@playing="handlePlaying"
				@progress="handleProgress" -->
      <source
        :src="videoBaseUrl + link.path"
        :type="'video/' + link.con_extension"
        v-for="link in currentLinks"
        :key="link.con_id"
      />
    </video>
    <!-- TODO REMOVE HARDCODE AFTER VIKTOR ADDS SUPPORT FOR THIS -->
    <!-- <img
			class="video"
			ref="fallback-image"
			:src="videoBaseUrl + '/data/WBSE Intro Loop.jpg'"
			@error="handleImageError"
			v-else
		/> -->
    <video-overlay
      :highlight-items="highlight"
      :video-elements="controller"
      :start="start"
      :video-ended="videoEnded"
      :key="videoReset + 1"
      @open-modal="openModal"
      @chat="$emit('chat')"
      ref="overlay"
    />
    <div class="icon-wrap" :class="{ fullscreen }">
      <div @click="handleFullScreen" v-if="!orientation && isMobile">
        <span
          class="material-icons"
          v-tooltip="{
            content: $t('tooltips.fullscreen'),
            position: 'BottomCenter',
          }"
        >
          {{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}
        </span>
      </div>
      <div
        v-if="videoEnded"
        @mousedown="handleHiglight(true)"
        @touchstart="handleHiglight(true)"
        @mouseup="handleHiglight(false)"
        @touchend="handleHiglight(false)"
        v-tooltip="$t('tooltips.links')"
      >
        <span class="material-icons">
          {{ highlight ? 'visibility' : 'visibility_off' }}
        </span>
      </div>
      <div v-else @click="skip" v-tooltip="$t('tooltips.skip')">
        <span class="material-icons">fast_forward</span>
      </div>
    </div>
  </div>
</template>

<script>
import VideoOverlay from './VideoOverlay'
import isMobileMixin from '../../mixins/isMobileMixin'
import { throws } from 'assert'
export default {
  components: {
    VideoOverlay,
  },
  props: {
    orientation: {
      type: Boolean,
    },
    controller: {
      type: Array,
    },
    links: {
      type: Array,
    },
    loopLinks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      highlight: false,
      fullscreen: false,
      start: false,
      videoEnded: false,
      videoLoadingError: false,
      imageFallbackTimer: null,
      timeIntervalRewind: null,
      videoCached: true,
      videoReset: 0,
      videoBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    }
  },
  mixins: [isMobileMixin],
  created() {
    if (this.$route.query.skip && this.loopLinks.length > 0) {
      this.videoEnded = true
    }
  },
  mounted() {
    // this.startLoading();
    setTimeout(() => {
      // this.stopLoading();
      this.$refs.video.play()
    }, 1000)
  },
  computed: {
    videoOgg() {
      return /.og\w$/.test(this.$refs.video.currentSrc)
    },
    currentLinks() {
      if (this.videoEnded && this.loopLinks.length > 0) {
        return this.loopLinks
      }
      return this.links
    },
    hideMenu() {
      return this.$route.query.hidemenu == 'true'
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.checkIfVideoEnded)
  },
  watch: {
    currentLinks: {
      deep: true,
      handler() {
        if (this.loopLinks.length === 0) {
          return
        }
        this.videoReset++
        this.startLoading()
        this.$nextTick(() => {
          this.$refs.video.play()
        })
      },
    },
    // starts loader when videos switch (intro/loop)
    // loader closes on @loadstart
    videoEnded(isTrue) {
      if (isTrue && this.loopLinks.length > 0) {
        this.startLoading()
      }
    },
  },
  methods: {
    init() {
      this.listenForStopVideo()
    },
    playRewind() {
      clearInterval(this.timeIntervalRewind)
      let rewindSpeed = 1
      let startSystemTime = new Date().getTime()
      let video = this.$refs.video
      let startVideoTime = video.currentTime

      this.timeIntervalRewind = setInterval(() => {
        video.playbackRate = 1.0
        if (video.currentTime === 0) {
          clearInterval(this.timeIntervalRewind)
          video.pause()
        } else {
          let elapsed = new Date().getTime() - startSystemTime
          video.currentTime = Math.max(
            startVideoTime - (elapsed * rewindSpeed) / 1000.0,
            0,
          )
        }
      }, 30)
    },
    handleNewDuration() {
      if (this.videoOgg) {
        this.videoCached = false
      }
    },
    skip() {
      this.videoEnded = true
      try {
        this.$refs.video.currentTime = this.$refs.video.duration
      } catch (error) {
        //
      }
    },
    handleHiglight(val) {
      this.highlight = val
    },
    handleFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    handleVideoError(e) {
      console.log(e)
      this.videoLoadingError = true
      // this.start = false
    },
    checkIfVideoEnded() {
      if (!this.$refs.video) {
        cancelAnimationFrame(this.checkIfVideoEnded)
      }
      if (this.$refs.video.ended) {
        this.videoEnded = true
        cancelAnimationFrame(this.checkIfVideoEnded)
        return
      }
      requestAnimationFrame(this.checkIfVideoEnded)
    },
    startImageFallback() {
      const SECONDS_TO_WAIT = 5
      let vid = this.$refs.video
      this.stopImageFallback()
      this.imageFallbackTimer = setTimeout(() => {
        if (vid.duration - vid.currentTime > 1) this.videoLoadingError = true
      }, SECONDS_TO_WAIT * 1000)
    },
    stopImageFallback() {
      if (this.imageFallbackTimer) {
        clearTimeout(this.imageFallbackTimer)
        this.imageFallbackTimer = null
      }
    },
    handleProgress() {
      this.stopImageFallback()
    },
    async handlePlaying() {
      this.stopImageFallback()
    },
    handleWaiting() {
      this.stopImageFallback()
      this.startImageFallback()
    },
    handleImageError() {
      console.log('IMAGE LOAD ERROR')
      this.retryFallbackImageLoad()
    },
    retryFallbackImageLoad() {},
    openModal(link) {
      this.$emit('open-modal', link)
    },
  },
}
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  .video {
    // remove if video not streched
    // max-height: calc(100vh - var(--nav-height));
    // width: calc(100vw - var(--nav-height) - 20px);
    width: 100vw;
    &.hide-menu {
      width: calc(100vw - 0px);
    }
    &.portrait {
      width: calc(100vw - 20px);
    }
  }
  &.fullscreen {
    width: max-content;
    .video {
      // remove if video not streched
      max-height: var(--page-height-portrait) !important;
    }
    .portrait {
      height: 100%;
      width: auto;
    }
  }
}
.cancel {
  pointer-events: none;
}
.icon-wrap {
  position: fixed;
  top: calc(3% + var(--nav-height));
  right: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  &.fullscreen {
    position: fixed;
    top: calc(3% + var(--nav-height));
  }
  &.home {
    right: 6%;
  }
  &.back {
    right: 9%;
  }
  div {
    border-radius: 50%;
    user-select: none;
    background: #ffffff93;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    margin: 0 5px;
  }
}
</style>
